import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { promotionSchema } from './promotion'

export const selectPromotionSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('select_promotion'),
  ecommerce: promotionSchema,
})
